import km from 'keymirror'
import _ from 'underscore'

const env = process.env || 'development'
export default _.extend(
  {
    SDYXMALL_MOVIE_HOST:
      env === 'development'
        ? `http://dev-m.sdyxmall.com/movie2/`
        : env === 'preview'
        ? `http://pre-m.sdyxmall.com/movie2/`
        : `https://m.sdyxmall.com/movie2/`,
    SDYXMALL_ACT_HOST:
      env === 'development'
        ? `http://dev-m.sdyxmall.com/act/`
        : env === 'preview'
        ? `http://pre-m.sdyxmall.com/act/`
        : `https://m.sdyxmall.com/act/`,
    SDYXMALL_MALL_HOST:
      env === 'development'
        ? `http://dev-m.sdyxmall.com/v1/#/`
        : env === 'preview'
        ? `http://pre-m.sdyxmall.com/v1/#/`
        : `https://m.sdyxmall.com/v1/#/`,

    MAIZUO_MOVIE_HOST:
      env === 'development'
        ? `http://m.maizuo.com/v5/?co=mzmovie`
        : `https://m.maizuo.com/v5/?co=mzmovie`,
    MAIZUO_MOVIE_VIP_HOST:
      env === 'development'
        ? `http://m.maizuo.com/v5/?co=mzmovie-vip`
        : `https://m.maizuo.com/v5/?co=mzmovie-vip`,

    EXPRESS_RULES_URL:
      env === 'development'
        ? 'http://dev-m.sdyxmall.com/act/active/SawLJH190601'
        : env === 'preview'
        ? 'https://pre-m.sdyxmall.com/act/active/SawLJH190601'
        : 'https://m.sdyxmall.com/act/active/SawLJH190601',

    COMMON_CHANNEL_ID: '1002',
    COMMON_DEFAULT_VERSION: '1.8.8',
    COMMON_DEFAULT_CO: 'sdyx',
    COMMON_PLATFORM_IS_WECHAT_SDYX_VIP: 'wechat_sdyx_vip',
    COMMON_PLATFORM_IS_WECHAT_SDYX: 'wechat_sdyx',
    COMMON_APP_SCHEME:
      'sdyx.mall://?at=<%-actionType%>&ad=<%-encodeURIComponent(actionData)%>',
    COMMON_APP_LINK:
      'https://m.sdyxmall.com/app/?at=<%-actionType%>&ad=<%-encodeURIComponent(actionData)%>',
    COMMON_SHARE_IMG_WATERMARK_SUFFIX:
      '?x-oss-process=image/resize,h_90,w_90/format,jpg/watermark,image_OWMyOTQ0ZTY5YzVhNDdhZDMzYTJhYTRkMjM2NDVkYzAuanBn,g_south,x_0,y_0',
    COMMON_SERVICE_PHONE: '400-1808-400',
    COMMON_SERVICE_TIME: '09:00-22:00',

    COMMON_QYG_CATEGORY_ID: '515',
  },
  km({
    COMMON_GETSMSCODE_SUCCESS: null,
    COMMON_GETSMSCODE_ERROR: null,
    COMMON_GETUSERINFO_SUCCESS: null,
    COMMON_GETUSERINFO_ERROR: null,
    COMMON_GETCAPTCHA_SUCCESS: null,
    COMMON_GETCAPTCHA_ERROR: null,
    COMMON_SENDWECHATMSGTPL_SUCCESS: null,
    COMMON_SENDWECHATMSGTPL_ERROR: null,
    COMMON_ISFOLLOWEDWECHAT_SUCCESS: null,
    COMMON_ISFOLLOWEDWECHAT_ERROR: null,
    /*yeoman-template-point-1*/
  })
)
